export const PHAN_LOAI_SAN_PHAM_PERMISSION_CODES = {
  WEB_BH_PHAN_LOAI_SAN_PHAM_LIST: 'WEB_BH_PHAN_LOAI_SAN_PHAM_LIST',
  WEB_BH_PHAN_LOAI_SAN_PHAM_ADD: 'WEB_BH_PHAN_LOAI_SAN_PHAM_ADD',
  WEB_BH_PHAN_LOAI_SAN_PHAM_EDIT: 'WEB_BH_PHAN_LOAI_SAN_PHAM_EDIT',
  WEB_BH_PHAN_LOAI_SAN_PHAM_DELETE: 'WEB_BH_PHAN_LOAI_SAN_PHAM_DELETE',
} as const
